<div class="cet-lang-toggler">
  <div class="langList-top">
    <p (click)="setArabic()">عربي</p>
    <p (click)="setEnglish()">english</p>
  </div>
  <input
    readonly
    value="{{ currentLangName }}"
    (focus)="open()"
    (blur)="close()"
  />
  <img src="assets/images/dropdownarrow.svg" alt="toggle dropdown" />
</div>
